import { BaseService } from "core/services";
import WoundPatientRouteService from "./WoundPatientRouteService";

class WoundPatientService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new WoundPatientRouteService());
    }
}

export default WoundPatientService;
